import { set } from "@/utils/vuex";

export default {
  setGoodCauseList: set("list"),
  setLoading: set("loading"),
  setCurrentProfile: set("currentProfile")
};
